import React from "react";

export default function GrainOverlay() {
    return <div className="lp-grain" aria-hidden="true" />;
}
